var _rect, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_243_1087",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_243_1087)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5948 7.17L7.59463 7.17C7.26384 7.1707 6.94675 7.30224 6.71259 7.5359C6.47843 7.76956 6.34622 8.08636 6.3448 8.41716V8.4175V18.3275C6.3448 18.6592 6.4764 18.9774 6.71071 19.2122C6.94502 19.447 7.26291 19.5793 7.59463 19.58H7.5948H14.6573C14.9895 19.58 15.3081 19.448 15.543 19.2132C15.7778 18.9783 15.9098 18.6597 15.9098 18.3275L15.9098 8.4175L15.9098 8.41716C15.9084 8.0859 15.7758 7.76869 15.5411 7.53496C15.3063 7.30122 14.9886 7.17 14.6573 7.17L7.5948 7.17ZM15.2498 18.3322C15.2486 18.4884 15.1856 18.6379 15.0747 18.748C14.9637 18.8582 14.8137 18.92 14.6573 18.92L7.5951 18.92C7.59502 18.92 7.59494 18.92 7.59486 18.92C7.43819 18.9194 7.28815 18.8567 7.17756 18.7457C7.06693 18.6346 7.0048 18.4843 7.0048 18.3275V8.41781C7.00604 8.26192 7.06866 8.11279 7.17911 8.00275C7.28959 7.89268 7.43901 7.83061 7.59496 7.83H14.6573C14.8144 7.83 14.9651 7.89242 15.0763 8.00354C15.1874 8.11465 15.2498 8.26536 15.2498 8.4225V18.3322Z",
    fill: "#534DE0",
    stroke: "#534DE0",
    strokeWidth: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08992 5.64233V5.6425V6.53C9.08992 6.61752 9.12469 6.70146 9.18658 6.76335C9.24846 6.82523 9.3324 6.86 9.41992 6.86C9.50744 6.86 9.59138 6.82523 9.65327 6.76335C9.71515 6.70146 9.74992 6.61752 9.74992 6.53V5.64266C9.75054 5.49325 9.81032 5.35016 9.91618 5.24471C10.0221 5.13922 10.1655 5.08 10.3149 5.08H17.4348C17.5835 5.08062 17.726 5.14013 17.8309 5.24552C17.936 5.35095 17.9949 5.49369 17.9949 5.6425V15.6096C17.9937 15.7579 17.9343 15.8997 17.8295 16.0045C17.7246 16.1094 17.5828 16.1688 17.4345 16.17H16.6249C16.5374 16.17 16.4535 16.2048 16.3916 16.2667C16.3297 16.3285 16.2949 16.4125 16.2949 16.5C16.2949 16.5875 16.3297 16.6715 16.3916 16.7333C16.4535 16.7952 16.5374 16.83 16.6249 16.83H17.4349H17.4351C17.7595 16.8293 18.0704 16.6999 18.2996 16.4703C18.5287 16.2406 18.6574 15.9294 18.6574 15.605V5.6425C18.6574 5.31827 18.5286 5.00733 18.2994 4.77806C18.0701 4.5488 17.7591 4.42 17.4349 4.42H10.3149C9.99049 4.42 9.67932 4.54869 9.44966 4.77785C9.22 5.007 9.09063 5.3179 9.08992 5.64233Z",
    fill: "#534DE0",
    stroke: "#534DE0",
    strokeWidth: 0.16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.d90c0f7e7f2ce34eaeea9f886f19b0b9.svg";
export { ForwardRef as ReactComponent };